import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
// @ts-ignore version of router
import { useSearchParams } from "react-router-dom";

const useTrackInfo = () => {
  const [track, setTrack] = useState("");
  const [raceNumber, setRaceNumber] = useState("");
  const [channel, setChannel] = useState("");
  const location = useLocation();
  const params = useParams<{ trackAbbr: string | undefined }>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const { pathname } = location;
    const number = searchParams.get("race");
    if (
      (pathname.includes("racetracks/") ||
        pathname.includes("livetracks/") ||
        pathname.includes("live/")) &&
      params.trackAbbr &&
      number
    ) {
      setRaceNumber(number);
      setTrack(params.trackAbbr);
      if (pathname.includes("livetracks/")) {
        setChannel("TVG");
      }
    } else {
      setRaceNumber("");
      setTrack("");
      setChannel("");
    }
  }, [location.pathname, location.search]);

  return { track, raceNumber, channel };
};

export default useTrackInfo;
